import React from "react";
import "./Tours.scss";
import Card from "../../UIComponents/Card/Card";
import Button from "../../UIComponents/Button/Button";

const Tours = () => {
  return (
    <section className="tours">
      <div className="u-center-text u-margin-bottom-big">
        <h2 className="heading-secondary u-margin-bottom-big">
          Most popular Tours
        </h2>
        <div className="row">
          <div className="col-1-of-3">
            <Card
              headerText={"enjoys our train"}
              Ndays={"3"}
              tours={"2"}
              sleep={"sleep in our lovely cabins"}
              Company={"21"}
              difficulity={"easy"}
              cost={"499"}
              numofcard={"1"}
            />
          </div>
          <div className="col-1-of-3">
            <Card
              headerText={"explore lakes"}
              Ndays={"7"}
              tours={"3"}
              sleep={"by request hotels can be provided"}
              Company={"30"}
              difficulity={"medium"}
              cost={"899"}
              numofcard={"2"}
            />
          </div>
          <div className="col-1-of-3">
            <Card
              headerText={"climb the alps"}
              Ndays={"30"}
              sleep={"tents and sleeping bags will be provided"}
              tours={"5"}
              Company={"4"}
              difficulity={"Hard"}
              cost={"40k"}
              numofcard={"3"}
            />
          </div>
        </div>
        <Button
          text="explore more"
          href="#popup"
          btnColor="btn-color-red-flag"
        />
      </div>
    </section>
  );
};

export default Tours;
